var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.056 9.134h17.415s6.011-.056 1.854 7.696c0 0-3.033 6.067-10.56 5.955l4.055-10.359a.82.82 0 0 0-.742-1.123l-5.337-.09-6.74 16.403s2.247.225 3.483.113l-.674 1.684h3.178a.427.427 0 0 0 .405-.281l.573-1.517 1.348-.112-.786 1.91h3.1a.56.56 0 0 0 .528-.36l.866-2.224s9.437-1.573 13.707-9.213c-.001 0 5.728-8.876-1.013-12.022a13.033 13.033 0 0 0-4.157-1.123l.787-1.944A.383.383 0 0 0 22.999 2h-2.911l-.9 2.36h-1.236l.696-1.832A.394.394 0 0 0 18.29 2h-2.92l-.9 2.36H5.394a1.348 1.348 0 0 0-1.19.707L2.055 9.134z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgb);
export default __webpack_public_path__ + "static/media/DGB.0299248674a7cec7009db48291860102.svg";
export { ForwardRef as ReactComponent };